import React from "react";

const HelpMenu = () => (
  <div className="dialog-content" style={{ padding: "0", minHeight: "0" }}>
    <ul>
      <li className="item">
        <a href="https://dragescent.fandom.com" target="blank" className="link">WIKI</a>
      </li>
      <li className="item">
        <a href="https://discord.gg/Fn6VcaF" className="link">DISCORD</a>
      </li>
      <li className="item">
        <a href="https://www.facebook.com/Dragescent/" className="link">FACEBOOK</a>
      </li>
      <li className="item">
        <a href="https://www.youtube.com/channel/UCsuMI2cAn2ZIsbyTN4vXOsA" className="link">YOUTUBE CHANNEL</a>
      </li>
      <li className="item">
        <a href={`${process.env.REACT_APP_API_URL}/helpdesk/outdisplay`} className="link">HELPDESK</a>
      </li>
    </ul>
  </div>
)

export default HelpMenu;
